import { lastValueFrom } from 'rxjs';

import {
  addAlert, primeurClearUser, primeurOnSubmit, primeurOnUpdate,
  setHashUser, setPrimeurUser, setPrimeurUserSuccess
} from '../slices/primeur.slice';

import { hideAlertPrimeurInfosModal, showAlertPrimeurInfosModal } from '../slices/gui.slice';
import { addApiErrorToast, addToast } from '../slices/toast.slice';
import { LocalStorageService } from '@/services/LocalStorage.service';
import { AppListenerEntry } from '@/redux';
import { KEYS } from '@/constants/keys';
import { MAIL_CHECK, UPDATE_PRIMEUR_USER } from '@/constants/primeur';

export const epicCheckPrimeurUser: AppListenerEntry = {
  actionCreator: setPrimeurUser,
  effect: async ({ payload }: ReturnType<typeof setPrimeurUser>, { dispatch, extra: { primeurService } }) => {
    try {
      const primeurUser: any = await lastValueFrom(primeurService.getPrimeurUser(payload.content as any));
      if (primeurUser) {
        dispatch(setPrimeurUserSuccess({ primeurUser }));
        dispatch(setHashUser({ hash: primeurUser.hash }));
      }
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicAlertMe: AppListenerEntry = {
  actionCreator: addAlert,
  effect: async ({ payload }: ReturnType<typeof addAlert>, { getState, dispatch, extra: { primeurService } }) => {
    const { storeId, alerts, isAllChecked, name } = payload;
    const { primeur, user } = getState();
    const connectedUser = user?.content;
    const { primeurUser } = primeur as any;

    if (primeurUser) {
      const userAlerts = computeAlerts(alerts, isAllChecked, primeurUser);
      try {
        const user = await lastValueFrom(primeurService.saveAlertList({
          hashPrimeurUser: primeurUser.hash,
          alerts: userAlerts
        }));
        dispatch(setPrimeurUserSuccess({ primeurUser: user }));
      } catch (error) {
        dispatch(addApiErrorToast({ error }));
      }
    } else if (connectedUser) {
      const userAlerts = computeAlerts(alerts, isAllChecked, primeurUser);
      try {
        const user = await lastValueFrom(primeurService.getPrimeurUser({
          idUser: connectedUser._id,
          alerts: userAlerts,
          toCreate: true,
          storeId
        }));

        dispatch(setPrimeurUserSuccess({ primeurUser: user }));
        dispatch(setHashUser({ hash: user?.hash }));
      } catch (error) {
        dispatch(addApiErrorToast({ error }));
      }
    } else {
      dispatch(showAlertPrimeurInfosModal({ products: alerts, name }));
    }
  }
};

export const epicOnSubmit: AppListenerEntry = {
  actionCreator: primeurOnSubmit,
  effect: async ({ payload }: ReturnType<typeof primeurOnSubmit>, { dispatch, extra: { primeurService } }) => {
    const { t, content } = payload;
    try {
      const result: any = await lastValueFrom(primeurService.checkPrimeurUserMail(content.email));
      if (result.isUser === MAIL_CHECK.IS_USER) {
        dispatch(addToast({ msg: t('errors.errorCodeMessage.1000') }));
      } else if (result.isUser === MAIL_CHECK.IS_PRIMEUR_USER) {
        dispatch(addToast({ msg: t('alert.emailAlreadyExist') }));
      } else {
        dispatch(setPrimeurUser({ content }));
        dispatch(hideAlertPrimeurInfosModal());
      }
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicOnUpdatePrimeurUser: AppListenerEntry = {
  actionCreator: primeurOnUpdate,
  effect: async ({ payload }: ReturnType<typeof primeurOnUpdate>, { dispatch, extra: { primeurService } }) => {
    const { t, idPrimeurUser, tel, countryPhone, email, warnByEmail, warnBySms } = payload;
    try {
      const userUpdate = await lastValueFrom(primeurService.updatePrimeurUser({
        idPrimeurUser, email, tel, countryPhone, warnByEmail, warnBySms
      }));

      if (userUpdate?.userUpdate === UPDATE_PRIMEUR_USER.ALREADY_EXIST) {
        dispatch(addToast({ msg: t('errors.errorCodeMessage.1000') }));
      } else if (userUpdate?.userUpdate === UPDATE_PRIMEUR_USER.UPDATED) {
        dispatch(addToast({ msg: t('alert.preferencesUpdated'), err: false }));
      } else {
        dispatch(addToast({ msg: t('errors.genericErrorMessage.403') }));
      }
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicUpdateHashUser : AppListenerEntry = {
  actionCreator: setHashUser,
  effect: ({ payload }: ReturnType<typeof primeurOnUpdate>) => {
    if ((payload as any).hash) {
      LocalStorageService.setObject(KEYS.HASH_USER, (payload as any).hash);
    }
  }
};

export const epicClearPrimeurUser: AppListenerEntry = {
  actionCreator: primeurClearUser,
  effect: (_action: ReturnType<typeof primeurClearUser>) => {
    LocalStorageService.remove(KEYS.HASH_USER);
  }
};

const computeAlerts = (alerts: string[], isAllChecked: boolean, primeurUser: { alerts: string[] }) => {
  const existingAlerts = primeurUser?.alerts || [];
  let res = [...existingAlerts];

  if (alerts.length > 0) {
    if (alerts.length === 1) {
      if (res?.includes(alerts[0])) {
        res = res.filter((id) => id !== alerts[0]);
      } else {
        res.push(alerts[0]);
      }
    } else if (isAllChecked) {
      alerts.forEach((partnumber) => res = res.filter((p) => p !== partnumber));
    } else {
      alerts.forEach((partnumber) => {
        if (!res.includes(partnumber)) {
          res.push(partnumber);
        }
      });
    }
  }

  return res;
};
